import React from 'react'
import { useNavigate } from 'react-router-dom';

const BlogCard = ({ blog }) => {

    const { title, description, category, image, _id } = blog;

    const navigate = useNavigate();

    return (
        <div onClick={() => navigate(`/blog/${_id}`)} className='w-full rounded-lg overflow-hidden shadow hover:scale-102 hover:shadow-primary/25 duration-300 cursor-pointer max-h-[350px]'>
            <div className='w-full h-[50%] object-contain'>
                <img src={image} alt='thumbnail' className='aspect-ratio w-full h-full' />
            </div>
            <div className='h-[50%]'>
                <div className='h-[30%] w-full'>
                    <span className='ml-5 mt-4 px-3 py-1 inline-block bg-primary/20 rounded-full text-primary text-xs'>{category}</span>
                </div>
                <div className='h-[70%] p-5'>
                    <h5 className='mb-2 font-medium text-gray-900'>{title}</h5>
                    <p className='mb-3 text-xs text-gray-600' dangerouslySetInnerHTML={{ __html: description.slice(0, 80) }}></p>
                </div>
            </div>
        </div>
    )
}

export default BlogCard